import React, { useState, useEffect } from 'react'
import WidgetContainer from '../WidgetContainer'
import styles from './styles.module.scss'
import Avatar from 'srcReact/components/common2/Avatar'
import IconButton from 'srcReact/components/common2/IconButton'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { getIconNameFromExtension } from 'srcReact/helpers/utils'
import TooltipWrapper from 'srcReact/components/common2/TooltipWrapper'
import MediaImage from 'srcReact/components/common2/MediaImage'
import { isFileImage } from 'srcReact/helpers/fileHelper'
import DocumentPreview from 'srcReact/MessengerPage/components/DocumentPreview'
import { formatDate, getDateFormat3 } from 'srcReact/helpers/datetimeHelper'

function RandomItems({
  totalCount,
  title,
  subTitle,
  type,
  items,
  handleShowMore,
  imageName,
  showImageModal,
  showUserModal
}) {
  const [itemList, setItemList] = useState([])
  const { t } = useTranslation()
  const dispatch = useDispatch()

  useEffect(() => {
    setItemList(items)
  }, [items])

  const handleShowUserModal = (user) => {
    if (showUserModal) {
      showUserModal(user)
    }
    // const lp = new LightProfileProto()
    // lp.userId = user.id
    // dispatch(lightProfileActions.openLightProfileModal(lp))
  }

  return (
    <WidgetContainer
      imageName={imageName}
      title={title}
      className={styles.widgetContainer}
      handleShowMore={handleShowMore}
      showMoreLabel={
        type === 'user'
          ? t('widgets.randomUsers.showMoreUsers')
          : type === 'media'
          ? t('widgets.randomMedia.showMoreMedia')
          : ''
      }>
      <div className={`${styles.randomContainer} ${type === 'latestmedia' && styles.randomContainerLatestMedia}`}>
        {totalCount && <h2 className={styles.count}>{totalCount}</h2>}
        {subTitle && <h3 className={styles.subTitle}>{subTitle}</h3>}
        <div className={`${styles.items} ${type === 'latestmedia' && styles.itemsWrapped}`}>
          {type === 'user' &&
            itemList &&
            itemList.map((user) => (
              <Avatar
                key={user.id}
                containerCSS={`${styles.avatar}`}
                imgWrapperSize='xsmall'
                userId={user.id}
                profilePicture={user.profile_picture}
                firstname={user.firstname}
                lastname={user.lastname}
                showImageAsDecorative={true}
                onClickAction={() => handleShowUserModal(user)}
                mimeType={user.mime_type}
                originalTag={user.original_tag}
                isOriginal={user.is_original}
                withExpertiseGroup={user.with_expertise_group}
              />
            ))}
          {(type === 'media' || type === 'latestmedia') &&
            itemList &&
            itemList.map((media) => {
              const filename = media.name || media.original_file_name
              const extension = filename.split('.').pop()
              const isImage = isFileImage(media)
              return isImage ? (
                <MediaImage
                  className={styles.btnImage}
                  file={media}
                  size={type === 'latestmedia' ? 'medium' : 'small'}
                  showPlainImageModal={showImageModal}
                />
              ) : type === 'latestmedia' ? (
                <DocumentPreview
                  showDate={true}
                  date={formatDate(media.created_at, getDateFormat3())}
                  documentNameCSS={styles.documentName}
                  documentNameMaxLength={40}
                  className={styles.document}
                  fileName={filename}
                  fileSize={media.original_file_size}
                  showDownload={true}
                  showOpened={true}
                  extension={filename.split('.').pop().toLowerCase()}
                  mimeType={media.mime_type}
                  isOriginal={media.is_original}
                  originalTag={media.original_tag}
                  path={media.url}
                  documentId={media.file_id}
                />
              ) : (
                <TooltipWrapper
                  triggerElement={
                    <IconButton className={styles.btnDoc} iconName={extension && getIconNameFromExtension(extension)} />
                  }
                  content={media.name}
                />
              )
            })}
        </div>
        {/* <IconButton
          iconName='arrow-right'
          iconSize='large32'
          aria-label={
            type === 'user'
              ? t('widgets.randomUsers.showMoreUsers')
              : type === 'media'
              ? t('widgets.randomMedia.showMoreMedia')
              : ''
          }
          onClick={handleShowMore}
          className={styles.btnShowMore}
        /> */}
      </div>
    </WidgetContainer>
  )
}

export default RandomItems
